import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { paymentTypes } from '../../data/payment-types';

function isPlanValid(plan, business) {
  var leadSource = business.leadSource;

  if (plan.title !== 'Basic') {
    return true;
  } // basic plans are shown if lead source is ChowNow before July 1st 2021


  return leadSource === 'ChowNow' && new Date() < new Date(2021, 6, 1);
}

export function getPlans(business) {
  var validPlans = paymentTypes.filter(function (plan) {
    return isPlanValid(plan, business);
  }).map(function (plan) {
    return _objectSpread({}, plan);
  });

  if (validPlans[0].title === 'Basic') {
    validPlans[1].qualitiesTitle = 'Everything in Basic +';
  }

  return validPlans;
}